import React from 'react';
import { Spin } from 'antd';
import style from './index.module.scss';

export default () => {
  return (
    <div className={style.container}>
      <Spin size="large" />
    </div>
  );
};
